import { render, staticRenderFns } from "./lstChooseRole.vue?vue&type=template&id=51c06b48&"
import script from "./lstChooseRole.vue?vue&type=script&lang=js&"
export * from "./lstChooseRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports